export const formatValuesToServerData = (values) => ({
  before_buffer_time: values.beforeBuffer,
  after_buffer_time: values.afterBuffer,
})
